import { styled, Typography } from '@mui/material';

export const Title = styled(Typography)`
  margin-bottom: 16px;
  font-size: 30px;
  line-height: 34px;
  font-weight: 700;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 24px;
    font-size: 36px;
    line-height: 43px;
  }
`;
